var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$.header, attrs: { id: "columns_sidebar_hedaer" } },
    [
      _c("div", { class: _vm.$.top, style: _vm.styles }, [
        _c(
          "div",
          { style: { marginRight: "4px" } },
          [
            _vm.backButton
              ? _c("icon-button", {
                  attrs: {
                    id: "gp_autotest_columns_bar_button_back",
                    icon: { name: "arrow-left" },
                    size: "small",
                  },
                  on: {
                    onClick: function ($event) {
                      return _vm.$emit("backClick")
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { class: _vm.$.title }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$.top__right },
          [
            _vm.helpButton
              ? _c("icon-button", {
                  style: { color: _vm.helpIconColor },
                  attrs: {
                    id: "gp_autotest_columns_bar_help",
                    icon: { name: "help" },
                    size: "small",
                  },
                  on: {
                    onClick: function ($event) {
                      return _vm.helpIconClick($event)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("icon-button", {
              attrs: {
                id: "gp_autotest_columns_bar_close",
                icon: { name: "close-1" },
                size: "small",
              },
              on: { onClick: _vm.onClose },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.tabs.length
        ? _c("vgp-tabs", {
            attrs: {
              tabs: _vm.tabs,
              "active-by": "type",
              active: _vm.activeTab,
              small: true,
              type: "tab",
              styles: { paddingLeft: "12px" },
              "gp-autotest-name": "gp_autotest_columns_bar_tabs",
            },
            on: { onToggle: _vm.onChangeTab },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }